import { LAMPORTS_PER_SOL } from '@solana/web3.js';
import BN from 'bn.js';

export const CreateTokenTransferToHolderDefaultPercentage = 79.31;

export const LiquidityV3ScannerInterval = 1000;

export const rapidLaunchMintAmount = 1000000000;
export const rapidLaunchTransferToHolderPercent = 79.31;
export const rapidLaunchBaseTotalLiquidity = new BN(206900000 * Math.pow(10, 6)); //
export const rapidLaunchQuoteTokenInitialLiquidity = new BN(79.005359057 * LAMPORTS_PER_SOL); //79.005359057 in production
export const rapidLaunchBundleBuyLimit = 4;
export const rapidLaunchTransactionsNumber = 4;
export const rapidLaunchDisperseForMixWalletFees = 0.02 * LAMPORTS_PER_SOL;
export const rapidLaunchDisperseForBundleBuyFeesExtra = 0.025 * LAMPORTS_PER_SOL;
export const rapidLaunchDisperseForFunder = 0.25 * LAMPORTS_PER_SOL;
export const rapidLaunchDisperseForHolder = 0.1 * LAMPORTS_PER_SOL;
export const rapidLaunchDisperseForFreezer = 0.25 * LAMPORTS_PER_SOL;
export const rapidLaunchVolumeBuyExtra = 0.02 * LAMPORTS_PER_SOL;

export const solManagerDisperseForMixWalletFees = 0.02 * LAMPORTS_PER_SOL;
export const solManagerDisperseForBundleBuyFeesExtra = 0.025 * LAMPORTS_PER_SOL;
export const solManagerVolumeBuyExtra = 0.02 * LAMPORTS_PER_SOL;

export const volumeMakerV2FeeReserve = 0.02 * LAMPORTS_PER_SOL;
export const volumeMakerV2CheckPoolBalanceLpSupplyUi = 1000; //min supply of LP tokens
export const volumeMakerV2CheckPoolBalanceSolUi = 1; //min pool balance in SOL

export const removeLiquidityPumspwapGoalReachedTicksToRemove = 3;

export const rapidPumpfunTimeoutRemoveSeconds = 1800;
